export enum ReloadKeys {
    SHOW_RELOAD = 'reload/SHOW_RELOAD',
    CLOSE_RELOAD = 'reload/CLOSE_RELOAD',
}

export interface ShowReload {
    type: ReloadKeys.SHOW_RELOAD;
    message: ReloadMessage;
}

export interface CloseReload {
    type: ReloadKeys.CLOSE_RELOAD;
}

export interface ReloadMessage {
    titleKey?: string;
    messageKey?: string;
}

export type ReloadAction = | ShowReload | CloseReload;

export const showReload = (message = {} as ReloadMessage): ShowReload => ({
    message,
    type: ReloadKeys.SHOW_RELOAD,
});

export const closeReload = (): CloseReload => ({
    type: ReloadKeys.CLOSE_RELOAD,
});
